// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DatasetVersionCreate
 */
export interface DatasetVersionCreate {
  /**
   *
   */
  storeRef: string;
  /**
   *
   */
  description?: string | null;
}

/**
 * Check if a given object implements the DatasetVersionCreate interface.
 */
export function instanceOfDatasetVersionCreate(value: object): value is DatasetVersionCreate {
  if (
    (!("storeRef" in (value as Record<string, any>)) &&
      !("store_ref" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["storeRef"] === undefined &&
      (value as Record<string, any>)["store_ref"] === undefined)
  )
    return false;
  return true;
}

export function DatasetVersionCreateFromJSON(json: any): DatasetVersionCreate {
  return DatasetVersionCreateFromJSONTyped(json, false);
}

export function DatasetVersionCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetVersionCreate {
  if (json == null) {
    return json;
  }
  return {
    storeRef: json["store_ref"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
  };
}

export function DatasetVersionCreateToJSON(json: any): DatasetVersionCreate {
  return DatasetVersionCreateToJSONTyped(json, false);
}

export function DatasetVersionCreateToJSONTyped(
  value?: DatasetVersionCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    store_ref: value["storeRef"],
    description: value["description"],
  };
}
